import { render, staticRenderFns } from "./invoiceRecords.vue?vue&type=template&id=3617e70d&"
import script from "./invoiceRecords.vue?vue&type=script&lang=js&"
export * from "./invoiceRecords.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3617e70d')) {
      api.createRecord('3617e70d', component.options)
    } else {
      api.reload('3617e70d', component.options)
    }
    module.hot.accept("./invoiceRecords.vue?vue&type=template&id=3617e70d&", function () {
      api.rerender('3617e70d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/Clearing/components/invoiceNo/invoiceRecords.vue"
export default component.exports